module.exports = __webpack_public_path__ + "img/Assets-16.6c328ed2.png";